module.exports = __webpack_public_path__ + "img/banner1.eb5aad74.png";